import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344eb730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "striping_work" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header_list" }
const _hoisted_4 = { class: "operation_box" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 4,
  class: "operation_box_btn_dis"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "mod_pagin"
}
const _hoisted_12 = { class: "create_modal" }
const _hoisted_13 = { class: "create_modal_line" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 直播剪辑名称：")
], -1))
const _hoisted_15 = { class: "create_modal_line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 直播流地址：")
], -1))
const _hoisted_17 = { class: "create_modal_line" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 存储方式：")
], -1))
const _hoisted_19 = { class: "create_modal_line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 存储地址：")
], -1))
const _hoisted_21 = { class: "create_modal_line line_align" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 开始时间：")
], -1))
const _hoisted_23 = { style: {"width":"100%"} }
const _hoisted_24 = { class: "create_modal_line_radio" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "直播开始前您可在云剪辑列表修改预约信息，直播开始后自动录制，同时可实时剪辑", -1))

import { reactive, ref } from 'vue';
import { Table, Pagination, Input, Tooltip, Modal, Select, Radio, DatePicker, message } from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import { pageConfig, stripingColumns, StripDataClass, StripData, CStripinData } from './type';
import { SearchOutlined } from '@ant-design/icons-vue';
import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import http from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'CloudStriping',
  setup(__props) {

const aTable = Table;
const aPagination = Pagination;
const aTooltip = Tooltip;
const aInputSearch = Input.Search;
const aModal = Modal;
const aSelect = Select;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aDatePicker = DatePicker;

const selectedRowKeys = ref();
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const keyword = ref('');
const searchChange = () => {
  getDataList();
};
const dataSource = ref<StripDataClass[]>([]);
const getDataList = () => {
  pageConfig.loading = true;
  http.application
    .search_editing_project({
      page: pageConfig.current,
      page_num: pageConfig.pageSize,
      keyword: keyword.value,
      ProjectType: 'LiveEditingProject',
    })
    .then((res) => {
      dataSource.value = res.data.data.data.map((e: StripData) => new StripDataClass(e));
      pageConfig.totalSize = res.data.data.total;
      pageConfig.current = res.data.data.current_page;
    })
    .finally(() => (pageConfig.loading = false));
};
getDataList();

const createStripingModal = reactive<RootModal>({
  title: '创建直播剪辑',
  visible: false,
  loading: false,
});
const openCreateStripingModal = () => {
  createStripingModal.visible = !createStripingModal.visible;
  if (createStripingModal.visible) {
    createStripinData.value.name = '';
    createStripinData.value.url = '';
    createStripinData.value.starTime = '';
    createStripinData.value.selectValue = undefined;
    createStripinData.value.timeType = 1;
  }
};
const createStripinData = ref<CStripinData>({
  name: '',
  url: '',
  modeStorage: '存储到视频点播',
  selectValue: undefined,
  options: [{ value: 0, label: 'outin-f78eae38aa2b11ea994400163e1a625e.oss-cn-shanghai.aliyuncs.com' }],
  timeType: 1,
  starTime: '',
});

const creatStriping = () => {
  const businessConfig = {
    OutputMediaConfig: { StorageLocation: 'outin-f78eae38aa2b11ea994400163e1a625e.oss-cn-shanghai.aliyuncs.com' },
    OutputMediaTarget: 'vod-media',
    ReservationTime: createStripinData.value.starTime ? createStripinData.value.starTime : undefined,
  };
  const stringArr = createStripinData.value.url.split('/');
  const liveStream = [
    {
      DomainName: stringArr[stringArr.length - 3],
      AppName: stringArr[stringArr.length - 2],
      StreamName: stringArr[stringArr.length - 1],
      LiveUrl: createStripinData.value.url,
    },
  ];
  const materialMaps = { liveStream: JSON.stringify(liveStream) };
  const data = {
    Title: createStripinData.value.name,
    ProjectType: 'LiveEditingProject',
    Source: 'LiveEditingConsole',
    MaterialMaps: JSON.stringify(materialMaps),
    BusinessConfig: JSON.stringify(businessConfig),
  };
  http.application
    .create_editing_project(data)
    .then(() => {
      message.success('创建成功！');
      openCreateStripingModal();
      getDataList();
    })
    .catch(() => message.error('创建失败！'));
};

const clickLook = (projectId: string) => {
  const url = 'http://test-clip.qing.tv' + '?ProjectId=' + projectId;
  window.open(url);
};
// 取消预约
const clickCancelReservation = (projectId: string) => {
  http.application
    .editing_project({ ProjectId: projectId, BusinessStatus: 'ReservationCanceled' })
    .then(() => {
      message.success('操作成功！');
      getDataList();
    })
    .catch(() => message.error('操作失败！'));
};
// 重新发起
const clickAgainLaunch = (projectId: string) => {
  Promise.all([
    http.application.get_editing_project({ ProjectId: projectId }),
    http.application.get_editing_project_materials({ ProjectId: projectId }),
  ]).then(([res1, res2]) => {
    const data = res1.data.data.Project;
    const config = JSON.parse(data.BusinessConfig);
    if (config.ReservationTime) {
      createStripinData.value.timeType = 2;
      createStripinData.value.starTime = config.ReservationTime;
    } else {
      createStripinData.value.timeType = 1;
      createStripinData.value.starTime = '';
    }
    createStripinData.value.name = data.Title;
    createStripinData.value.selectValue = 0;
    createStripinData.value.url = res2.data.data.LiveMaterials[0].LiveUrl;
    createStripingModal.visible = true;
  });
};
// 删除
const delModal = reactive<RootModal>({
  title: '删除',
  visible: false,
  loading: false,
});

const projectId = ref('');
const openDelModal = (ProjectId: string) => {
  delModal.visible = true;
  projectId.value = ProjectId;
};
const closeDelModal = () => {
  delModal.visible = false;
};
const delStriping = () => {
  delModal.loading = true;
  http.application
    .delete_editing_projects({ ProjectIds: projectId.value })
    .then(() => {
      message.success('删除成功！');
      delModal.visible = false;
      getDataList();
    })
    .catch(() => message.error('删除失败！'))
    .finally(() => (delModal.loading = false));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(aInputSearch), {
        class: "mod_range_picker_search",
        value: keyword.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        placeholder: "请输入云拆条名称",
        onSearch: searchChange
      }, {
        enterButton: _withCtx(() => [
          _createVNode(_unref(SearchOutlined), { color: "#fff" })
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: openCreateStripingModal
      }, {
        default: _withCtx(() => [
          _createTextVNode("新建云拆条")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(aTable), {
        "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
        columns: _unref(stripingColumns),
        "data-source": dataSource.value,
        scroll: { x: 1000, y: false },
        pagination: false,
        loading: _unref(pageConfig).loading,
        rowKey: "projectId"
      }, {
        operation: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(aTooltip), null, {
              title: _withCtx(() => []),
              default: _withCtx(() => [
                (record.status === '直播结束')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "operation_box_btn",
                      onClick: ($event: any) => (clickLook(record.projectId))
                    }, " 视频剪辑 ", 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (record.status === '预约取消')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "operation_box_btn",
                      onClick: ($event: any) => (clickAgainLaunch(record.projectId))
                    }, " 重新发起 ", 8, _hoisted_6))
                  : _createCommentVNode("", true),
                (record.status === '预约中')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "operation_box_btn",
                      onClick: ($event: any) => (clickCancelReservation(record.projectId))
                    }, " 取消预约 ", 8, _hoisted_7))
                  : _createCommentVNode("", true),
                (record.status === '直播中')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "operation_box_btn",
                      onClick: ($event: any) => (clickLook(record.projectId))
                    }, "查看", 8, _hoisted_8))
                  : _createCommentVNode("", true),
                (record.status === '加载失败')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "查看"))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_unref(aTooltip), null, {
              title: _withCtx(() => []),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "operation_box_btn",
                  onClick: ($event: any) => (openDelModal(record.projectId))
                }, " 删除 ", 8, _hoisted_10)
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["row-selection", "columns", "data-source", "loading"]),
      (dataSource.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_unref(aPagination), {
              "show-quick-jumper": "",
              total: _unref(pageConfig).totalSize,
              current: _unref(pageConfig).current,
              "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pageConfig).current) = $event)),
              "page-size": _unref(pageConfig).pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pageConfig).pageSize) = $event)),
              pageSizeOptions: _unref(pageConfig).options,
              "show-less-items": "",
              "show-size-changer": "",
              onChange: getDataList,
              onShowSizeChange: getDataList
            }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(aModal), {
        visible: createStripingModal.visible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((createStripingModal.visible) = $event)),
        title: createStripingModal.title,
        centered: "",
        width: "630px",
        onOk: creatStriping
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_a_input, {
                value: createStripinData.value.name,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((createStripinData.value.name) = $event)),
                placeholder: "请输入直播剪辑名称"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_a_input, {
                value: createStripinData.value.url,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((createStripinData.value.url) = $event)),
                placeholder: "请输入直播流地址"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", null, _toDisplayString(createStripinData.value.modeStorage), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_unref(aSelect), {
                value: createStripinData.value.selectValue,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((createStripinData.value.selectValue) = $event)),
                options: createStripinData.value.options,
                placeholder: "请选择",
                class: "create_modal_line_sel"
              }, null, 8, ["value", "options"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_unref(aRadioGroup), {
                    value: createStripinData.value.timeType,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((createStripinData.value.timeType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aRadio), { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("立即开始")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(aRadio), { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("从预约时间开始")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                (createStripinData.value.timeType === 2)
                  ? (_openBlock(), _createBlock(_unref(aDatePicker), {
                      key: 0,
                      value: createStripinData.value.starTime,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((createStripinData.value.starTime) = $event)),
                      "show-time": "",
                      placeholder: "请选择时间",
                      class: "create_modal_line_picker"
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                _hoisted_25
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        close: closeDelModal,
        ok: delStriping,
        loading: delModal.loading
      }, null, 8, ["visible", "loading"])
    ])
  ]))
}
}

})